export enum BookingPageQuestionsAnswerTypeEnum {
  shortText = 'short_text',
  longText = 'long_text',
  radioButtons = 'radio_buttons',
  checkboxes = 'checkboxes',
  dropdown = 'dropdown',
  phoneNumber = 'phone_number',
}
